export interface GetValidationReportTokenResponse {
    token: string;
}
